import { combineReducers } from 'redux';
import ContestSeriesReducer from '../contests/reducer';
import AuthReducer from '../auth/reducer';
import CoinPriceReducer from '../coinPrices/reducer';
import { ExchangesReducer } from '../labs/ExchangesReducer';

export default combineReducers({
  contestSeries: ContestSeriesReducer,
  auth: AuthReducer,
  coinPrices: CoinPriceReducer,
  exchanges: ExchangesReducer,
});
